<template>
    <div ref="bing" class="bing"></div>
  </template>
  
  <script>
  import * as echarts from 'echarts';
  
  export default {
    name: "StorelocationBing",
    data() {
      return{
        data:{},
        option : {
          tooltip: {
            trigger: 'item'
          },
          legend: {
            left: "10%",
            top: "10%",
            orient: "vertical",
            textStyle:{
              color:"#fff"
            }
          },
          series: [
            {
              name: '门店个数',
              left: '30%',
              top: '15%',
              height:"85%",
              type: 'pie',
              radius: ['40%', '70%'],
              avoidLabelOverlap: false,
              label: {
                show: false,
                position: 'center'
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: '26',
                  fontWeight: 'bold'
                }
              },
              labelLine: {
                show: false
              },
              data: [
                   {
                    name: '餐饮类门店',
                    value: 119
                    },
                    {
                    name: '零售类门店',
                    value: 180
                    },
                    {
                    name: '服务类门店',
                    value: 141
                    },
                    {
                    name: '其他特色类型',
                    value: 9
                    }
              ]
            }
          ]
        }
      }
    },
    methods: {
      init() {
        this.myChart = echarts.init(this.$refs.bing);
        this.myChart.setOption(this.option);
      },
    },
    mounted() {
      let user_id = window.localStorage.getItem('user_id');
  
      const data = {
        'user_id': user_id
      };
  
  
        this.option ={
          tooltip: {
            trigger: 'item'
          },
          legend: {
            left: "10%",
            top: "10%",
            orient: "vertical",
            textStyle:{
              color:"#fff"
            }
          },
          series: [
            {
              name: '门店个数',
              left: '30%',
              top: '15%',
              height:"85%",
              type: 'pie',
              radius: ['40%', '70%'],
              avoidLabelOverlap: false,
              label: {
                show: false,
                position: 'center'
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: '26',
                  fontWeight: 'bold'
                }
              },
              labelLine: {
                show: false
              },
              data: [
                    {
                    name: '餐饮类门店',
                    value: 119
                    },
                    {
                    name: '零售类门店',
                    value: 180
                    },
                    {
                    name: '服务类门店',
                    value: 141
                    },
                    {
                    name: '其他特色类型',
                    value: 9
                    }
              ]
            }
          ]
        }
        this.myChart = echarts.init(this.$refs.bing);
        this.myChart.setOption(this.option);
   
    },
    watch: {
      data(value) {
        this.option.data = value;
        this.myChart.setOption(this.option);
      },
    }
  }
  </script>
  
  <style scoped>
   .bing{
     height: 100%;
     width: 100%;
   }
  </style>